import React from "react";
import "./button.css"; // Import styles
const Button = ({ size = "medium", label, onClick, loading, isLoading, className = "", icon, disabled = false, type }) => {
  const busy = loading || isLoading;
  return (
    <button
      type={type}
      disabled={disabled || busy}
      aria-busy={busy || undefined}
      className={`${className} cmn_btn btn-${size} ${icon ? "d-flex gap-2 align-items-center" : ""}`}
      onClick={onClick}
    >
      {icon && icon} {label}
    </button>
  );
};

export default Button;
